// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListToolbar-components-MergeStudiesButton-module__popoverContent";
export { _1 as "popoverContent" }
